<template>
  <div class="promo-images">
    <HeadSection title='Media' :permissionOfSection="activeMedia">
      <template #actions>
        <a-col :span="14" class="text-right">
          <div>
            <a-button v-if="!isViewscreen" type="default" size="large" class="mr-3" @click="openExportModal"
              :disabled="loading">
              <a-icon type="upload" />
              Export
            </a-button>
            <a-button v-if="!isViewscreen" type="primary" size="large"
              style="font-size: 16px; font-weight: 300; border-radius: 2px" @click="createMedia"
              :disabled="!permissionCreate">
              <a-icon type="plus" /> Add
            </a-button>
            <a-button v-else type="primary" size="large"
              style="font-size: 16px; font-weight: 300; border-radius: 2px" @click="addToSection"
              :disabled="!mediaToViewscreenArray.length">
              <a-icon type="plus" /> Save
            </a-button>
          </div>
        </a-col>
      </template>
    </HeadSection>
    <MainContainer :loading="userLoading || loading" :permissionOfSection="activeMedia" isTabs>
      <div class="promo-images__tabs">
        <div ref="tabs" class="promo-images__tabs__container">
          <a-tabs v-model="activeMedia" type="card" class="viewscreen-tabs__card" @change="onTabChange" destroyInactiveTabPane>
            <a-tab-pane v-for="mediaType in mediaTypes" :key="mediaType.value" :tab="mediaType.name" :disabled="isTabDisabled(mediaType.value)">
              <div v-if="isViewscreen" class="d-flex justify-content-end">
                <span class="text-gray-7 mr-4">{{ imageCounter }} </span>
                 <a-checkbox :checked="isAddAllChecked" @change="handleAddAllMedia"><span class="font-weight-bold">Select all</span></a-checkbox>
              </div>
              <div ref="mediaHeader" class="media-header d-flex align-items-center justify-content-between" :class="{ 'pinned': isFilterHeaderPinned }">
                <div class="d-flex">
                  <AppSelect v-model="filters.applicationId" :apps="apps" :allowСlear="false" class="mr-3" :disabled="loading"
                    style="width: 220px;"/>
                  <LocalizationsSelect v-model="filters.localizationId" :localizations="languagesOptions"
                    :disabled="loading" class="mr-4" />
                  <ActiveStatus v-model="filters.active" :disabled="loading" />
                </div>
                <div class="d-flex align-items-end">
                  <a-form-model-item class label="Search field:" :colon="false">
                    <a-select v-model="filters.selectedSearch" size="large" style="width: 140px" class="mr-2">
                      <a-select-option v-for="option in searchOptions" :key="option.value" :value="option.value">
                        {{ option.title }}
                      </a-select-option>
                    </a-select>
                  </a-form-model-item>
                  <a-input-search style="width: 300px; height: 40px;" size="large"
                    v-model="filters.search" :placeholder="searchPlaceholder" allow-clear enter-button
                    :disabled="loading" />
                </div>
              </div>
              <div class="promo-content">
                <component v-if="activeComponent !== undefined"
                  :is="activeComponent"
                  :editPermission="editPermission"
                  :filters="filters"
                  :filtersReady="filtersReady"
                  :languages="languages"
                  :isViewscreen="isViewscreen"
                  :isAddAllChecked="isAddAllChecked"
                  :mediaToViewscreenArray="mediaToViewscreenArray"
                  :displays="displays"
                  @changeMediaArray="addToMediaArray"
                  @mediaToSplice="deleteFromMediaArray"
                  @changeAllChecked="changeAllChecked"
                />
              </div>
            </a-tab-pane>
          </a-tabs>
        </div>
      </div>
    </MainContainer>
    <a-modal v-model="isExportModalOpen" title="Export" :footer="null" width="450px" :destroyOnClose="true">
      <ExportModal
        :options="exportOptions"
        :startExport="startExport"
        :checkExport="checkExport"
        @close="closeExportModal"
      />
    </a-modal>
  </div>
</template>
<script>
import { mapState } from 'vuex'
import AppSelect from '@/components/custom/filters/appSelect.vue'
import LocalizationsSelect from '@/components/custom/filters/localizationsSelect.vue'
import ActiveStatus from '@/components/custom/filters/activeStatus.vue'
import HeadSection from '@/components/main/headSection'
import MainContainer from '@/components/main/mainContainer'
import BannersList from '@/views/apps/media/components/banners/bannersList.vue'
import StoriesList from '@/views/apps/media/components/stories/storiesList.vue'
import SplashscreenList from '@/views/apps/media/components/splashscreens/splashscreenList.vue'
import InformersList from '@/views/apps/media/components/informers/informersList.vue'
import PopupsList from '@/views/apps/media/components/popups/popupsList.vue'
import ExportModal from '@/components/custom/modals/export/exportModal.vue'

import MediaService from '@/services/api/apiMediaService'
import ViewscreenService from '@/services/api/apiViewscreenService'
import accessMix from '@/services/accessmix.js'
import apiClient from '@/services/axios'
import { routerPushWithFilters } from '@/services/utils/routerHelpers'

const defaultFilters = {
  applicationId: undefined,
  localizationId: undefined,
  active: true,
  search: undefined,
  selectedSearch: 'name',
}

const exportOptions = [
  { value: 'banner', name: 'Banners' },
  { value: 'story', name: 'Stories' },
  { value: 'informer', name: 'Informers' },
  { value: 'popup_banner', name: 'Popup-banners' },
  { value: 'media', name: 'All' },
]

export default {
  name: 'Media-list',
  mixins: [accessMix],
  components: {
    HeadSection,
    MainContainer,
    AppSelect,
    ActiveStatus,
    LocalizationsSelect,
    BannersList,
    StoriesList,
    SplashscreenList,
    InformersList,
    PopupsList,
    ExportModal,
  },
  props: {
    // createPermission: {
    //   type: Boolean,
    //   default: false,
    // },
    // editPermission: {
    //   type: Boolean,
    //   default: false,
    // },
  },
  data() {
    return {
      exportOptions,
      mediaTypes: [
        { value: 'banners', name: 'Banners', component: 'BannersList' },
        { value: 'stories', name: 'Stories', component: 'StoriesList' },
        // { value: 'splashscreens', name: 'Splashscreens', component: 'SplashscreenList' },
        { value: 'informers', name: 'Informers', component: 'InformersList' },
        { value: 'popup-banners', name: 'Pop-up banners', component: 'PopupsList' },
      ],
      activeMedia: 'banners',
      isExportModalOpen: false,
      languagesLoading: false,
      loading: false,
      apps: undefined,
      languages: [],
      searchOptions: [
        { title: 'UUID', value: 'uuid' },
        { title: 'Name', value: 'name' },
      ],
      filters: { ...defaultFilters },
      filtersReady: false,
      isAddAllChecked: false,
      mediaToViewscreenArray: [],
      isProgrammaticFilterUpdate: false,
      isExportOpen: false,
      isFilterHeaderPinned: false,
      filterObserver: null,
      displays: {
        1: 'Live',
        2: 'Line',
        3: 'Promo',
        4: 'Main Web',
        5: 'Registration',
        6: 'Side menu',
        7: 'Bottom menu',
      },
    }
  },
  computed: {
    ...mapState(['user']),
    userLoading() {
      return this.$store.state?.user?.loading || false
    },
    languagesOptions() {
      return this.languages.map(function (row) {
        return { value: row.id, label: row.desc }
      })
    },
    permissionCreate() {
      return this.checkPermissions(this.user.permissions, `${this.activeMedia}`, 'create')
    },
    editPermission() {
      return this.checkPermissions(this.user.permissions, `${this.activeMedia}`, 'edit')
    },
    searchPlaceholder() {
      return this.filters.selectedSearch === 'name' ? 'Enter name' : 'Enter UUID'
    },
    activeComponent() {
      return this.mediaTypes.find(media => media.value === this.activeMedia)?.component || null
    },
    isViewscreen() {
      return !!this.$route.params.sectionId
    },
    imageCounter () {
      return `${this.mediaToViewscreenArray.length} ${this.mediaToViewscreenArray.length === 1 ? 'image' : 'images'} selected`
    },
    defaultApp() {
      if (!this.apps.length) {
        return null
      }
      return this.apps.find(app => app.is_default === 1)
    },
  },
  async created() {
    await this.fetchApplications()
    if (this.defaultApp) {
      this.filters.applicationId = this.defaultApp.application_id
    }
    await this.fetchLocalizations()
    if (!this.$route.params.mediaType) {
      this.onTabChange('banners')
    } else {
      this.setFiltersFromQuery()
    }
    this.filtersReady = true
  },
  mounted() {
    this.tryObserveSticky()
  },
  beforeDestroy() {
    if (this.filterObserver) this.filterObserver.disconnect()
  },
  watch: {
    '$route.params.mediaType': {
      immediate: true,
      handler(newMediaType) {
        this.activeMedia = newMediaType
      },
    },
    filters: {
      handler(newFilters) {
        if (this.isProgrammaticFilterUpdate) {
          this.isProgrammaticFilterUpdate = false
          return
        }
        const queryObj = JSON.parse(JSON.stringify(this.$route.query))

        for (const key in queryObj) {
          let val = queryObj[key]

          if (val === 'true') val = true
          else if (val === 'false') val = false
          else if (!isNaN(val) && val.trim() !== '') val = Number(val)

          queryObj[key] = val
        }

        const filteredQuery = Object.fromEntries(
          Object.entries(newFilters).filter(([key, value]) => value !== undefined && value !== null && value !== '' && key !== 'selectedSearch' && key !== 'search'),
        )

        if (newFilters.selectedSearch) {
          filteredQuery[newFilters.selectedSearch] = newFilters.search
        }

        if (JSON.stringify(queryObj) !== JSON.stringify(filteredQuery)) {
          this.$router.push({ query: filteredQuery })
        }
      },
      deep: true,
    },
  },
  methods: {
    waitForHeader() {
      return new Promise(resolve => {
        const check = () => {
          const header = this.$refs.mediaHeader?.[0] ?? (!Array.isArray(this.$refs.mediaHeader) && this.$refs.mediaHeader)
          if (header) {
            resolve(header)
          } else {
            requestAnimationFrame(check)
          }
        }
        check()
      })
    },
    async tryObserveSticky() {
      const header = await this.waitForHeader()
      if (!header) return

      // Create a sentinel above the sticky element to detect when it leaves viewport
      const sentinel = document.createElement('div')
      sentinel.style.position = 'absolute'
      sentinel.style.top = `${header.offsetTop - 1}px`
      sentinel.style.height = '1px'
      sentinel.style.width = '100%'
      header.parentElement.insertBefore(sentinel, header)

      this.filterObserver = new IntersectionObserver(
        ([entry]) => {
          // When sentinel goes out of view (header is pinned)
          this.isFilterHeaderPinned = !entry.isIntersecting
        },
        {
          root: null,
          threshold: [1],
          rootMargin: '-120px 0px 0px 0px',
        },
      )

      this.filterObserver.observe(sentinel)
    },
    isTabDisabled(tabValue) {
      if (!this.isViewscreen) return false

      const currentType = this.$route.params.mediaType

      if (['stories', 'banners'].includes(currentType)) {
        return !['stories', 'banners'].includes(tabValue)
      }

      return currentType !== tabValue
    },
    onTabChange(mediaType) {
      this.isProgrammaticFilterUpdate = true
      this.activeMedia = mediaType

      this.filters.localizationId = undefined
      this.filters.active = true
      this.filters.search = undefined
      this.filters.selectedSearch = 'name'

      const viewscreenId = this.$route.params.viewscreenId
      const sectionId = this.$route.params.sectionId

      this.$router.push({
        name: 'Media',
        params: {
          mediaType,
          ...(this.isViewscreen && viewscreenId ? { viewscreenId } : {}),
          ...(this.isViewscreen && sectionId ? { sectionId } : {}),
        },
        query: {
          ...this.$route.query,
          active: 'true',
        },
      })

      if (this.filterObserver) this.filterObserver.disconnect()

      this.$nextTick(() => {
        this.isProgrammaticFilterUpdate = false
        this.isAddAllChecked = false

        this.tryObserveSticky()
      })
    },
    setFiltersFromQuery() {
      this.filters.applicationId = this.$route.query.applicationId
        ? Number(this.$route.query.applicationId)
        : this.defaultApp.application_id

      this.filters.localizationId = this.$route.query.localizationId ? Number(this.$route.query.localizationId) : undefined

      this.filters.active = this.$route.query.active !== undefined ? this.$route.query.active === 'true' : true

      this.filters.search = this.$route.query.name || this.$route.query.uuid || undefined

      if (this.$route.query.name) {
        this.filters.selectedSearch = 'name'
      } else if (this.$route.query.uuid) {
        this.filters.selectedSearch = 'uuid'
      }
    },
    createMedia() {
      routerPushWithFilters(this.$router, `/media/${this.activeMedia}/create`)
    },
    redirectToMain() {
      this.$router.push(`/main/${this.$route.params.viewscreenId}`)
    },
    openExportModal() {
      this.isExportModalOpen = true
    },
    closeExportModal() {
      this.isExportModalOpen = false
    },
    async startExport(type) {
      return await MediaService.startExport({ type })
    },
    async checkExport(type) {
      return await MediaService.checkExportStatus(type)
    },
    async fetchApplications() {
      this.loading = true
      try {
        const url = '/admin/applications'
        const response = await apiClient.get(url)
        if (response.data.data) {
          this.apps = response.data.data
        }
      } finally {
        this.loading = false
      }
    },
    async fetchLocalizations() {
      this.loading = true
      const url = '/admin/localizations'
      try {
        const response = await apiClient.get(url)
        this.languages = response.data.data
      } catch (error) {
        console.log('Error while trying to get locales', error)
      } finally {
        this.loading = false
      }
    },
    handleAddAllMedia() {
      this.isAddAllChecked = !this.isAddAllChecked
    },
    changeAllChecked(type) {
      this.isAddAllChecked = type
    },
    addToMediaArray(newMedia) {
      const existing = this.mediaToViewscreenArray

      const newItems = newMedia.filter(
        media => !existing.some(exist => exist.id === media.id && exist.type === media.type),
      )

      this.mediaToViewscreenArray = [...existing, ...newItems]
    },
    deleteFromMediaArray(mediaToDelete, type) {
      const toDelete = Array.isArray(mediaToDelete)
        ? mediaToDelete.map(item => typeof item === 'object' ? item : { id: item, type })
        : [{ id: mediaToDelete, type }]

      this.mediaToViewscreenArray = this.mediaToViewscreenArray.filter(
        media => !toDelete.some(item => media.id === item.id && media.type === item.type),
      )
    },
    async addToSection () {
      this.loading = true
      try {
        const itemIds = this.mediaToViewscreenArray.map(item => item.id)
        const response = await ViewscreenService.addMultipleSectionItems(this.$route.params.sectionId, { item_ids: itemIds })
        if (response.data.data) {
          this.$notification.success({
            message: 'Media items has been successfully added to the viewscreen section',
          })
        }
        this.redirectToMain()
      } catch (e) {
        this.$notification.error({
          message: 'Error while adding media items to viewscreen section',
          description: e.response.data.error.message,
        })
        this.loading = false
      } finally {
        this.loading = false
      }
    },
  },
}
</script>
<style lang="scss">
.promo-images {
    &__tabs {

        &__container {
            &>.ant-tabs-card>.ant-tabs-content {
                margin-top: -17px;
            }

            &>.ant-tabs-card>.ant-tabs-content>.ant-tabs-tabpane {
                border: solid #e4e9f0;
                border-width: 0 1px 1px 1px;
                border-radius: 0 4px 4px 4px;
                background: #fff;
                padding: 16px;
            }

            & .ant-tabs-content>.ant-tabs-tabpane-inactive {
                border: none !important;
            }

            &>.ant-tabs-card>.ant-tabs-bar {
                display: flex;
                border-color: #fff;
            }

            &>.ant-tabs-card>.ant-tabs-bar {
                justify-content: space-between;
                color: #595959;
                border-color: transparent;
                background: transparent;

                &:not(.ant-tabs-tab-active) {
                    background-color: #f5f5f5 !important;
                }
            }

            &>.ant-tabs-card>.ant-tabs-bar .ant-tabs-tab-active {
                border-color: #fff;
                background: #fff;
            }

            & .ant-tabs-tab {
                margin-right: 2px !important;
            }
        }
    }
}

.media-header {
  position: sticky;
  top: 130px;
  height: 100%;
  z-index: 5;
  background: #fff;
  margin-bottom: 20px;

  &::before {
    content: '';
    position: absolute;
    background: #fff;
    height: 80px;
    width: 110%;
    top: 50%;
    transform: translateY(-50%);
    left: -47px;
    z-index: -1;
    opacity: 0;
    transition: opacity 0.1s ease-in;
  }

  &.pinned::before {
    opacity: 1;
  }

  .ant-form-item {
    margin-bottom: -1px;
  }
}

.ant-tabs {
  overflow: initial !important;
}
</style>
